import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { VendorMiArea } from 'src/app/models/department-reports.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import {shareReplay} from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-vendor-mi-area-report',
  templateUrl: './vendor-mi-area-report.component.html',
  styleUrls: ['./vendor-mi-area-report.component.scss']
})
export class VendorMiAreaReportComponent implements OnInit {

  vendorMiArea: any[];
  verfAppArea:any;
  pendingArea:any;
  incompleteAppArea:any;
  rejectedAppArea:any;
  changeRequestAppArea:any;
  totalAppArea:any;
  targetArea:any;
  grandVerfAppArea:number;
  grandPendingArea:number;
  grandIncompleteAppArea:number;
  grandRejectedAppArea:number;
  grandChangeRequestAppArea:number;
  grandTotalAppArea:number;
  grandTargetArea:number;
  arrayIndex:number;
  tempVendorMiArea: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: VendorMiArea[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  
  public userID: any;
  displayMaximizable:boolean;
  displayMaximizable_totalApp:boolean;
  displayMaximizable_pendingApp:boolean;
  drilldownDetails:any;
  pendingType:any;
  displayMaximizable_rejectedApp:any;
  vendorName:any;
  name:any;
  routePath:any;
  subjectSub:any;
  selectedYear:any;
  public subscriptions: any = [];
  public loading: boolean = false;
  constructor(private reportsService:ReportsService
     ,private messageService:MessageService
     ,private dashboard: DashboardService
     ,private router: Router
     ,private activityRecordService: ActivityRecordService
     ,private loader: AppLoaderService
     ,private service: BaseService
     ,private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    // this.routePath=router.split('/')
        
      this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
        
        this.loadData(this.selectedYear)
      }
          
  );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Vendor_MI_Area_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "Vendor_MI_Area_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  loadData(selectedYear:any){
    // this.loader.start();
    this.loading = true;
    let sub=this.reportsService.getVendorMIArea_Report(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.activityRecordService.activityRecord(this.userID, 'Vendor MI Area Report', '', new Date(), 'Success');
           // this.loader.close();
           this.loading = false;
            // console.log("dataaa", data)
            if (data?.length > 0) {
              this.vendorMiArea = data;
              this.appVerificationModel = data;
              this.tempVendorMiArea=data;
              this.arrayIndex=0;
              this.calculateGrandTotal()
             
            }
            else{
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.vendorMiArea = [];
              this.appVerificationModel =[] ;
              this.tempVendorMiArea=[];
              this.arrayIndex=0;
              this.calculateGrandTotal()
            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            // this.activityRecordService.activityRecord(this.userID, 'Vendor MI Area Report', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        return {
          "Vendor Name" : d.vendorName,
          "Programme Name" : d.ProgrammeName,
          "Verified App Area": d.Verified_App_Area,
          "Pending App Area": d.Pending_App_Area,
          "Incomplete App Area": d.Incomplete_App_Area,
          "Rejected App Area": d.Rejected_App_Area,
          "changeRequest App Area": d.changeRequest_App_Area,
          "Total App Area": d.Total_App_Area,
          "Target Area": d.TargerArea,
        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'vendorName', header: 'Vendor Name'},
      {field: 'ProgrammeName', header: 'Programme Name'},
      { field: 'Verified_App_Area', header: 'Verified App Area' },
      { field: 'Pending_App_Area', header: 'Pending App Area' },
      {field: 'Incomplete_App_Area', header: 'Incomplete App Area'},
      {field: 'Rejected_App_Area', header: 'Rejected App Area'},
      {field: 'changeRequest_App_Area', header: 'changeRequest App Area'},
      {field: 'Total_App_Area', header: 'Total App Area'},
      {field: 'TargerArea', header: 'Target Area'},
     
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  tableDataFunction(event: any) {
    this.tempVendorMiArea=event.filteredValue
    //console.log(event);
    this.arrayIndex=0;
    // console.log(this.vendorWise);
    this.calculateTotalApp() ;
  }
  onPage(event:any) {
        this.arrayIndex=event.first;
        this.calculateTotalApp()
        //console.log(event);
      }
calculateTotalApp() {
        this.verfAppArea=0;
        this.pendingArea=0;
        this.incompleteAppArea=0;
        this.rejectedAppArea=0;
        this.changeRequestAppArea=0;
        this.totalAppArea=0;
        this.targetArea=0;
        for(let i=this.arrayIndex ;this.tempVendorMiArea.length>10?i<this.arrayIndex+10:i<this.tempVendorMiArea.length;i++) {
          //console.log( this.totalApp,"totalAPPPPPPPPP")
          this.verfAppArea +=this.tempVendorMiArea[i].Verified_App_Area;
          this.pendingArea +=this.tempVendorMiArea[i].Pending_App_Area;
          this.incompleteAppArea += this.tempVendorMiArea[i].Incomplete_App_Area;
          this.rejectedAppArea += this.tempVendorMiArea[i].Rejected_App_Area;
          this.changeRequestAppArea += this.tempVendorMiArea[i].changeRequest_App_Area;
          this.totalAppArea += this.tempVendorMiArea[i].Total_App_Area;
          this.targetArea +=this.tempVendorMiArea[i].TargerArea;

        }
        this.verfAppArea= this.verfAppArea.toFixed(4);
        this.pendingArea=this.pendingArea.toFixed(4);
        this.incompleteAppArea=this.incompleteAppArea.toFixed(4);
        this.rejectedAppArea=this.rejectedAppArea.toFixed(4);
        this.changeRequestAppArea= this.changeRequestAppArea.toFixed(4);
        this.totalAppArea=this.totalAppArea.toFixed(4);
        this.targetArea=this.targetArea.toFixed(4);

    }
    calculateGrandTotal(){
      this.grandVerfAppArea=0;
      this.grandPendingArea=0;
      this.grandIncompleteAppArea=0;
      this.grandRejectedAppArea=0;
      this.grandChangeRequestAppArea=0;
      this.grandTotalAppArea=0;
      this.grandTargetArea=0;
      for(let vendorData of this.tempVendorMiArea) {
        this.grandVerfAppArea += vendorData.Verified_App_Area;
        this.grandPendingArea += vendorData.Pending_App_Area;
        this.grandIncompleteAppArea += vendorData.Incomplete_App_Area;
        this.grandRejectedAppArea += vendorData.Rejected_App_Area;
        this.grandChangeRequestAppArea += vendorData.changeRequest_App_Area;
        this.grandTotalAppArea += vendorData.Total_App_Area;
        this.grandTargetArea += vendorData.TargerArea;
    }
    }

    showMaximizableDialog(value:any,status:any,vendorName:any,programId:any) {
      
      this.name=status;
      this.vendorName=vendorName;
      // console.log(vendorName,"this.vendorName")
      this.drilldownDetails={
        actionType:"VendorMIArea",
        
        filterType:"Vendor",
        value:value,
        status:status,
        MIType:programId
      }
      
      this.displayMaximizable = true;
      // console.log(this.value,"value")
      // console.log(this.drilldownDetails,"this.drilldownDetails1212122")
  
  } 
  showMaximizableDialog_totalApp(value:any,status:any,vendorName:any,programId:any) {
        
        
    this.vendorName=vendorName;
    this.drilldownDetails={
      actionType:"VendorMIArea",
      status:status,
      filterType:"Vendor",
      value:value,
      MIType:programId
    }
    
    this.displayMaximizable_totalApp = true;
  
    // console.log(this.value,"value")
    // console.log(this.drilldownDetails,"this.drilldownDetails")
  
  }
  showMaximizableDialog_pending(value:any,status:any,vendorName:any,programId:any) {
        
    
    this.vendorName=vendorName;
    this.drilldownDetails={
      actionType:"VendorMIArea",
      status:status,
      filterType:"Vendor",
      value:value,
      MIType:programId
    }
    
    this.displayMaximizable_pendingApp = true;
    // console.log(this.value,"value")
    // console.log(this.drilldownDetails,"this.drilldownDetails")
  
  }
  showMaximizableDialog_rejected(value:any,status:any,vendorName:any,programId:any) {
        
        
    this.vendorName=vendorName;
    this.drilldownDetails={
      actionType:"VendorMIArea",
      status:status,
      filterType:"Vendor",
      value:value,
      MIType:programId
    }
    
    this.displayMaximizable_rejectedApp = true;
  
    // console.log(this.value,"value")
    // console.log(this.drilldownDetails,"this.drilldownDetails")
  
  }

}
